import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "@/assets/js/request";
import mixin from "@/mixin/global-mixin";
import "swiper/css/swiper.css";

//按需引入
// import element from "@/assets/js/element-ui";
// Vue.use(element);

//全量引入
import ElementUI from "element-ui";
import "@/assets/theme/index.css";
Vue.use(ElementUI);

import QueryConditionBox from "@/components/query-condition-box";
import XkwTable from "@/components/xkw-table";
import HrBar from "@/components/hr-bar";
import XkwPagination from "@/components/xkw-pagination";
import IconType from "@/components/icon-type";

Vue.component(QueryConditionBox.name, QueryConditionBox);
Vue.component(XkwTable.name, XkwTable);
Vue.component(HrBar.name, HrBar);
Vue.component(XkwPagination.name, XkwPagination);
Vue.component(IconType.name, IconType);

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.mixin(mixin);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
